<template lang="html">
    <section class="basket col-md-12">
        <div class="row">
            <div class="basket-list col-lg-9 col-md-12 col-xs-12">
                <div v-if="getBasket.basketType" class="basket-status">
                    <i class="fas fa-lock fa-1x"></i>
                    {{ $t("basket.statusBasket").replace("{status}", getBasket.basketType.terms.name[$t("trad")].value) }}
                </div>
                <div class="basket-list-content">
                    <h1 v-if="getBasket.name" class="basket-list-title">{{ $t("basket.titleDetails") }} '{{ getBasket.name }}'</h1>
                    <BasketList :datasListBaskets="getBasket"></BasketList>
                </div>
            </div>

            <div class="basket col-lg-3 col-md-12 col-xs-12" v-if="typeof getBasket.items !== 'undefined' && getBasket.items.length > 0">
                <div style="background: white;"><BasketOrder :datasListBaskets="getBasket"></BasketOrder></div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import BasketList from './BasketList'
import BasketOrder from './BasketOrder'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'basket',
    props: ['listItems'],
    data () {
        return {
            datasListBaskets: []
        }
    },
    components: {
        BasketList,
        BasketOrder
    },
    methods: {
        ...mapActions("basket/details", {
            getBasketAction: "getBasketAction",
            updateBasket: "updateBasket"
        }),
        basketDetails () {
            this.getBasketAction(this.$route.params.id)
        }
    },
    computed: {
        ...mapGetters("basket/details", {
            getBasket: "getBasket"
        })
    },
    mounted () {
        this.basketDetails()
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";
.basket {
    &-list {
        & .basket-status {
            color: white;
            position: absolute;
            padding: 8px 5px;
            font-size: 13px;
            text-transform: uppercase;
            right: 40px;
            background-color: $color2;
        }
        &-content {
            background: white;
            padding: 10px;
        }
        &-title {
            font-size: 21px;
            font-family: "oswald-regular", sans-serif;
            font-weight: normal;
            @media only screen and (max-width: 767px) {
                margin-top: 35px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Basket.vue?e94284d2